import React from "react";
import SiteHeader from "../components/SiteHeader";
import About from "../components/About";
import Contact from "../components/Contact";
import SiteFooter from "../components/SiteFooter";

export default function Home() {

  return (
    <div className="container" >
      <main className="markdown-body">
        <SiteHeader />
        <About />
        <Contact />
        <SiteFooter />
      </main>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/views/Home.js